import React from 'react';
import { motion } from 'framer-motion';
import { Eye, Target, Zap, Heart, Shield } from 'lucide-react';
import './AboutPage.css';

const AboutPage = () => {
  const values = [
    {
      title: "Innovation",
      description: "We constantly push the boundaries of what's possible with modern technology.",
      icon: <Zap className="value-icon" />
    },
    {
      title: "Reliability",
      description: "We build robust systems that businesses can depend on 24/7.",
      icon: <Shield className="value-icon" />
    },
    {
      title: "User-Centric",
      description: "Everything we build starts and ends with the user experience.",
      icon: <Heart className="value-icon" />
    }
  ];

  const team = [
    {
      name: "Alex Rivers",
      role: "Lead Architect",
      expertise: "System Design & AI",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=256&h=256&auto=format&fit=crop"
    },
    {
      name: "Sarah Chen",
      role: "Senior Developer",
      expertise: "Full-Stack & Cloud",
      image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=256&h=256&auto=format&fit=crop"
    },
    {
      name: "Marcus Thorne",
      role: "UI/UX Director",
      expertise: "Visual Design",
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?q=80&w=256&h=256&auto=format&fit=crop"
    }
  ];

  return (
    <motion.div 
      className="about-page"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <section className="about-hero">
        <div className="container">
          <motion.h1
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
          >
            Engineering the <span>Digital Future</span>
          </motion.h1>
          <motion.p
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.1 }}
          >
            Amavix Tech is a collective of engineers and designers dedicated to building high-performance software that solves real business problems.
          </motion.p>
        </div>
      </section>

      <section className="about-mission">
        <div className="container">
          <div className="mission-grid">
            <motion.div 
              className="mission-card"
              whileInView={{ y: 0, opacity: 1 }}
              initial={{ y: 20, opacity: 0 }}
              viewport={{ once: true }}
            >
              <div className="mc-icon-wrapper"><Target /></div>
              <h3>Our Mission</h3>
              <p>To empower businesses by delivering scalable, secure, and user-centric technical solutions that drive growth and innovation.</p>
            </motion.div>
            <motion.div 
              className="mission-card"
              whileInView={{ y: 0, opacity: 1 }}
              initial={{ y: 20, opacity: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1 }}
            >
              <div className="mc-icon-wrapper"><Eye /></div>
              <h3>Our Vision</h3>
              <p>To be the leading engineering partner for startups and enterprises seeking to build the next generation of digital products.</p>
            </motion.div>
          </div>
        </div>
      </section>

      <section className="about-values">
        <div className="container">
          <h2 className="section-title text-center">Our Core <span>Values</span></h2>
          <div className="values-grid">
            {values.map((v, i) => (
              <motion.div 
                key={i} 
                className="value-card"
                whileInView={{ scale: 1, opacity: 1 }}
                initial={{ scale: 0.9, opacity: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
              >
                {v.icon}
                <h4>{v.title}</h4>
                <p>{v.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="about-team">
        <div className="container">
          <h2 className="section-title text-center">The <span>Experts</span> Behind Amavix</h2>
          <div className="team-grid">
            {team.map((member, i) => (
              <motion.div 
                key={i} 
                className="team-card"
                whileInView={{ y: 0, opacity: 1 }}
                initial={{ y: 20, opacity: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
              >
                <div className="tm-image">
                  <img src={member.image} alt={member.name} />
                </div>
                <div className="tm-info">
                  <h4>{member.name}</h4>
                  <p className="tm-role">{member.role}</p>
                  <p className="tm-expertise">{member.expertise}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </motion.div>
  );
};

export default AboutPage;
